import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { GoalMultiplierCanSpinModal } from "./GoalMultiplierCanSpinModal";
import { GoalMultiplierMiniWheel } from "./GoalMultiplierMiniWheel";
import cls from "./styles.module.scss";

export const GoalMultiplierCanSpinMarker = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const goalMultiplierValues = useGoalsStore((state) => state.initData?.multiplier?.wheel_values);

  if (!goalMultiplierValues || goalMultiplierValues.length === 0) return null;

  return (
    <>
      <button
        className={cls.canSpinMarker}
        type="button"
        onClick={() => setIsModalOpen(true)}
        aria-label={t("goals.multiplier.multiplyBonus")}
      >
        <GoalMultiplierMiniWheel />
        <span className={cls.canSpinPill}>
          {t("goals.multiplier.multiplyBonus")}
        </span>
      </button>

      <GoalMultiplierCanSpinModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        goalMultiplierValues={goalMultiplierValues}
      />
    </>
  );
};
